/** Rótulo da versão que está no ar, no rodapé da barra lateral. */
export function rotuloDaVersaoRodando(versao: string): string {
  return `versão ${versao}`;
}
